var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"color":"lightNeutral","rounded":"","small":""},on:{"click":function($event){return _vm.changeRegisterDialogState(true,false)}}},[_vm._v("إنشاء حساب")])}
var staticRenderFns = []

export { render, staticRenderFns }